import { KeplerVisualChannel } from 'features/builder/types'
import { CHANNEL_SCALES } from '@carto/kepler.gl/constants'

type VisualChannelKey = 'color' | 'strokeColor' | 'size' | 'radius' | 'height' | 'weight'

type VisualChannelConfig = Omit<KeplerVisualChannel, 'nullValue' | 'defaultValue'>

export const visualChannelsConfigs: Record<VisualChannelKey, VisualChannelConfig> = {
  // visual channel used by most layers for fillColor
  color: {
    key: 'color',
    property: 'color',
    field: 'colorField',
    scale: 'colorScale',
    domain: 'colorDomain',
    range: 'colorRange',

    aggregation: 'colorAggregation',
    channelScaleType: CHANNEL_SCALES.color
  },

  // visual channel used by most layers for stroke/outline color
  strokeColor: {
    key: 'strokeColor',
    property: 'strokeColor',
    opacityProperty: 'strokeOpacity',
    field: 'strokeColorField',
    scale: 'strokeColorScale',
    domain: 'strokeColorDomain',
    range: 'strokeColorRange',

    aggregation: 'strokeColorAggregation',
    channelScaleType: CHANNEL_SCALES.color
  },

  // Visual channel used by most layers for stroke/outline width
  // Old document mode layers used it differently:
  //   - point used it for radius of point
  //   - grid/hex use this channel for height
  size: {
    // Kepler names this channel as size, but it should be strokeWidth
    property: 'size',
    field: 'sizeField',
    scale: 'sizeScale',
    domain: 'sizeDomain',
    range: 'sizeRange',
    key: 'size',
    channelScaleType: CHANNEL_SCALES.size,
    aggregation: 'sizeAggregation'
  },
  radius: {
    // Used for point layers
    property: 'radius',
    field: 'radiusField',
    scale: 'radiusScale',
    domain: 'radiusDomain',
    range: 'radiusRange',
    key: 'radius',
    channelScaleType: CHANNEL_SCALES.radius,
    aggregation: 'radiusAggregation'
  },
  height: {
    property: 'height',
    field: 'heightField',
    scale: 'heightScale',
    domain: 'heightDomain',
    range: 'heightRange',
    key: 'height',
    channelScaleType: CHANNEL_SCALES.size,
    aggregation: 'heightAggregation'
  },
  weight: {
    key: 'weight',
    property: 'weight',
    field: 'weightField',
    scale: 'weightScale',
    domain: 'weightDomain',
    range: 'weightRange',
    channelScaleType: CHANNEL_SCALES.size,
    aggregation: 'weightAggregation'
  }
} as const
